<app-header></app-header>

<div class="bg-image-container">
    <div class="container" style="max-width: 1200px;">
        <div class="logo-container">
            <img src="/assets/logo-pagalo-pe.png" alt="Logo de la empresa" class="img-fluid">
        </div>
    </div>
</div>

<div class="payment-section py-5">
    <div class="container" style="max-width: 1200px;">
        <h2 class="text-center mb-4">
            <strong><span style="color: #B72727;">Selecciona</span> cómo deseas realizar tu pago</strong>
        </h2>

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#mobile">
                    <i class="fas fa-mobile-alt"></i> Desde la App
                </button>
            </li>
            <li class="nav-item">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#internet">
                    <i class="fas fa-laptop"></i> Desde la Web
                </button>
            </li>
        </ul>

        <div class="tab-content mt-4">
            <div class="tab-pane fade show active" id="mobile">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <img src="assets/pagalo-pe-movil.png" alt="Págalo.pe Móvil" class="img-fluid">
                    </div>
                    <div class="col-md-7">
                        <h5 class="fw-bold mb-4">Pasos para pagar desde el aplicativo</h5>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <p>Abre el aplicativo de <strong>Pagalo.pe</strong></p>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <p>Ingresa tu <strong>usuario</strong> y <strong>contraseña</strong>. Si no tienes
                                    cuenta debes registrarte con un correo
                                    electrónico.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <p>Clic en <strong>Agregar pago</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">4</div>
                                <p>Busca y selecciona <strong>"01111 - Centro de Innovación Productiva y Transferencia
                                        Tecnológica (CITE)"</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">5</div>
                                <p>Selecciona el tipo de documento: <strong>DNI</strong> o <strong>RUC</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">6</div>
                                <p>Ingresa el <strong>número de documento</strong>.</p>
                            </div>
                            <!-- <div class="step">
                                <div class="step-number">7</div>
                                <p>En el campo CITE, ingresa el <strong>código del CITE</strong> que viene en la
                                    proforma.</p>
                            </div> -->
                            <div class="step">
                                <div class="step-number">7</div>
                                <p>En el campo CITE, ingresa el <strong><a href="#" style="color: #B72727;"  data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasCite">código del CITE</a></strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">8</div>
                                <p>Ingresa el <strong>costo del servicio</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">9</div>
                                <p>Clic en <strong>Agregar al carrito</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">10</div>
                                <p>Verfica los datos y dale clic en <strong>aceptar los términos y condiciones</strong>.
                                </p>
                            </div>
                            <div class="step">
                                <div class="step-number">11</div>
                                <p>Clic en <strong>pagar</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">12</div>
                                <p>Selecciona el <strong>método de pago</strong>, ingresa los datos solicitados y haz
                                    clic en <strong>Pagar</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">13</div>
                                <p>Te indicará que el pago fue confirmado. Puedes descargar la constancia, el
                                    comprobante te llegará al correo electrónico con el que iniciaste.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="internet">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <img src="assets/pagalo-pe-web.png" alt="Págalo.pe Web" class="img-fluid">
                    </div>
                    <div class="col-md-7">
                        <h5 class="fw-bold mb-4">Pasos para pagar desde la web</h5>
                        <div class="steps-container">
                            <div class="step">
                                <div class="step-number">1</div>
                                <p>Ingresa a <a href="https://pagalo.pe/" target="_blank" rel="noopener noreferrer"
                                        style="color: #B72727; font-weight: bold;">Pagalo.pe</a></p>
                            </div>
                            <div class="step">
                                <div class="step-number">2</div>
                                <p>Ingresar tu <strong>usuario</strong> y <strong>contraseña</strong>. Si no tienes
                                    cuenta debes registrarte con un correo
                                    electrónico.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">3</div>
                                <p>En la barra de búsqueda, busca y selecciona: <strong>"01111 - Centro de Innovación
                                        Productiva y Transferencia Tecnológica (CITE)"</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">4</div>
                                <p>Seleccionar el tipo de documento: <strong>DNI</strong> o <strong>RUC</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">5</div>
                                <p>Ingresa el <strong>número de documento</strong>.</p>
                            </div>
                            <!-- <div class="step">
                                <div class="step-number">6</div>
                                <p>En el campo CITE, ingresa el <strong>código del CITE</strong> que viene de la
                                    proforma.</p>
                            </div> -->
                            <div class="step">
                                <div class="step-number">6</div>
                                <p>En el campo CITE, ingresa el <strong><a href="#" style="color: #B72727;" data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasCite">código del CITE</a></strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">7</div>
                                <p>Ingresar el <strong>costo</strong> del servicio.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">8</div>
                                <p>Click en <strong>Agregar al carrito</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">9</div>
                                <p>Verfica los datos y dale clic en <strong>aceptar los términos y condiciones</strong>.
                                </p>
                            </div>
                            <div class="step">
                                <div class="step-number">10</div>
                                <p>Clic en <strong>pagar</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">11</div>
                                <p>Selecciona el <strong>método de pago</strong>, ingresa los datos solicitados y haz
                                    clic en <strong>Pagar</strong>.</p>
                            </div>
                            <div class="step">
                                <div class="step-number">12</div>
                                <p>Te indicará que el pago fue confirmado. Puedes descargar la constancia, el
                                    comprobante te llegará al correo electrónico con el que iniciaste.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container" style="padding-top: 50px; padding-bottom: 50px; display: flex; justify-content: center;">
    <a href="/" class="btn btn-warning">
        <i class="bi bi-arrow-90deg-left me-3"></i>Volver atrás
    </a>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasCite" style="width: 500px;">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title">Códigos CITE / UT</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>
    <div class="offcanvas-body p-4">
        <div class="mb-3">
            <p>A continuación se listan <strong>los códigos de los CITE's</strong>. Puedes hacer clic en el <strong>ícono</strong> para copiar el código.</p>
        </div>
    
        <div>
            <label class="pb-2">Buscar CITE:</label>
            <div class="input-group mb-3">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" id="searchCite" class="form-control" placeholder="Ingrese el nombre del CITE" [(ngModel)]="buscar">
            </div>
        </div>
        
        <table class="table">
            <thead>
                <tr>
                    <th>Copiar</th>
                    <th>Serie</th>
                    <th>CITE / UT</th>
                </tr>
            </thead>
            <tbody>
                @for (cite of citesFiltrados; track cite.codigo) {

                    <tr>
                        <td>
                            <i class="bi bi-copy" (click)="copiarCodigo(cite.codigo, $event)" style="cursor: pointer; margin-left: 10px;"></i>
                        </td>
                        <td>{{cite.codigo}}</td>
                        <td>{{cite.nombre}}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>


<app-footer></app-footer>